import React from 'react';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { fetchMappingZunsolar, fetchAllMapping } from '../../actions/fetchAllMapping';
import { editBulkLeads } from '../../actions/editMultipleLeadsAction';
import { leadTransferGet } from '../../actions/leadTransferAction';
import { render } from '@testing-library/react';
import Header from '../../components/HeaderComponent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ErrorComponent } from '../../components/ErrorComponent';
import { Loader } from '../../components/loader';
import { zunsolarLeadTransferColumns } from '../../config/column_fields';
import ZunsolarLeadTransferComponent from '../../components/zunsolar/ZunsolarLeadTransferComponenet'

class ZunSolarLeadTransfer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      recieved: false
    }
  }
  componentWillMount() {
    let viewList = ["employees"]
    this.props.fetchAllMapping(viewList);
    this.props.fetchMappingZunsolar();
  }

  render() {
    if (this.props.error) {
      return (
        <div>
          <ErrorComponent error={this.props.error} />
        </div>
      )
    }

    return (
      <div>
        <Header />
        <ZunsolarLeadTransferComponent allMapping={this.props.allMapping} leadTransferGet={this.props.leadTransferGet} leadTransferData={this.props.leadTransferData} editBulkLeads={this.props.editBulkLeads} />
      </div>
    )
  }
}


function mapStateToProps(state) {
  // console.log("searchData", state)

  return {
    allMapping: state.fetchAllMapping ? state.fetchAllMapping : {},
    leadTransferData: state.leadTransferData ? state.leadTransferData : {}
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchMappingZunsolar, fetchAllMapping, leadTransferGet, editBulkLeads }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ZunSolarLeadTransfer);